'use client';

import {ScrollArea} from "@/components/ui/scroll-area";
import {EventList} from "@/app/events/components/EventList";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious
} from "@/components/ui/pagination";
import {
  currentPage,
  eventList,
  handleNextPage,
  handlePreviousPage,
  isFirstPage,
  isLastPage,
  setIsAnyFitters,
  totalPages
} from "@/app/events/store/event-list.store";
import {useSignals} from "@preact/signals-react/runtime";
import {useRouter} from "next/navigation";

// import your FilterBadges here
import {FilterBadges} from "./FilterBadges";

export const EventListContainer = ({params}) => {
  useSignals();
  const router = useRouter();

  return (
    <>
      <ScrollArea className="mb-10 min-h-[75vh]">
        
        <FilterBadges params={params} onAnyChangesInFilters={setIsAnyFitters} />
        <EventList params={params} />

        <br />

        <Pagination className={eventList.value.length === 0 ? 'hidden' : ''}>
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                onClick={() => handlePreviousPage(router.push)}
                aria-disabled={isFirstPage.value}
                className={isFirstPage.value ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink isActive>{currentPage.value}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <span className="text-sm text-muted-foreground">of</span>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink>{totalPages.value}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationNext
                onClick={() => handleNextPage(router.push)}
                aria-disabled={isLastPage.value}
                className={isLastPage.value ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </ScrollArea>
    </>
  );
};
